module.exports = __webpack_public_path__ + "img/Bigfoot-School-Education.864069b9.jpg";